import { InputFieldCompact } from '@swegon-core/uic';
import { SelectFieldOption } from '@swegon-core/uic/dist/src/components/forms/types';
import {
    UnitSelectorContainer,
    UnitSelectorLabel
} from './UnitSelector.styles';

export interface UnitSelectorProps {
    id: string;
    label: string;
    options: SelectFieldOption[] | undefined;
    selectedUnit: string;
    onUnitChange: (newUnit: string) => void;
}
const UnitSelector = ({
    id,
    label,
    onUnitChange,
    options,
    selectedUnit
}: UnitSelectorProps) => (
    <UnitSelectorContainer>
        <UnitSelectorLabel>{label}</UnitSelectorLabel>
        <InputFieldCompact
            id={id}
            aria-label={label}
            type={'select'}
            options={options}
            value={selectedUnit}
            onChange={onUnitChange}
        />
    </UnitSelectorContainer>
);

export default UnitSelector;
